'use client';

import React from 'react';
import styles from './sectionPanel.module.scss';
import { useTrack } from '@chewy/use-analytics';
import { KibIngressCard } from '@chewy/kib-cards-react';
import '@chewy/kib-cards-styles/dist/styles/kib-ingress-card.css';
import { navigateToAnchor } from '@/utils/helpCenterUtils';
import { useRouter } from 'next/navigation';

export interface SectionPanelProps {
  readonly section: any | undefined | null;
  readonly popularTopic?: string;
}

const SectionPanel = ({ section, popularTopic }: SectionPanelProps): React.ReactElement | null => {
  const router = useRouter();
  const track = useTrack();

  const handleArticleClick = (section: any) => {
    const obj: any = section;

    const eventName = popularTopic ? 'Popular Topics Link Clicked' : 'Topics Section Link Clicked';
    const eventProperties = {
      id: 'section-panel-article-button-id',
      parentId: 'section-panel-id',
      level: 'section-panel',
      type: 'static',
      position: 1,
      event_name: 'Link Clicked',
      eventAction: 'click',
      eventCategory: 'help-center-landing-page',
      eventLabel: `help-center-landing-page-${popularTopic || 'topic-section'}-click`,
      name: eventName,
      articleId: obj?.id,
      articleTitle: obj?.title,
      articleCategoryId: obj?.categoryId,
      sectionId: obj?.sectionId,
      sectionTitle: obj?.sectionTitle,
      sectionCategoryId: obj?.sectionCategoryId,
      topicId: obj?.topicId,
      topicTitle: obj?.topicTitle,
      topicCategoryId: obj?.topicCategoryId
    };
    track(eventName, eventProperties);

    navigateToAnchor(obj?.id, router);
  };

  if (!section?.id) {
    return null;
  }

  return (
    <li key={section.id} className={styles.linkItem}>
      <KibIngressCard
        className={styles.linkContent}
        title={section.title}
        onClick={() => handleArticleClick(section)}
        aria-label={`View ${section.title} article`}
        aria-describedby={`section-${section.id}-desc`}
      />
    </li>
  );
};

export default SectionPanel;
